import React from 'react';
import DsButton from '../../common/DsButton';
import DsSelect from '../../common/DsSelect';
import { formatItemCount } from '../../../utils/datetime';

function PageSizeSelector({ pageSizeOptions, handlePageSizeChange, itemsPerPage, variant = 'default' }) {
  return (
    <label className={`page-size-selector${variant === 'compact' ? ' page-size-selector--compact' : ''}`}>
      <span className="sr-only">1ページの表示件数</span>
      <DsSelect
        className="page-size-selector__control"
        value={itemsPerPage}
        onChange={(e) => handlePageSizeChange(Number(e.target.value))}
        aria-label="1ページの表示件数"
      >
        {pageSizeOptions.map((size) => (
          <option key={size} value={size}>{formatItemCount(size)}</option>
        ))}
      </DsSelect>
    </label>
  );
}

function ViewModeSwitch({ setViewMode, viewMode, label = '表示切り替え' }) {
  return (
    <div className="segmented view-toggle-btns" aria-label={label}>
      <DsButton
        type="button"
        variant="secondary"
        icon
        className={`view-action ${viewMode === 'card' ? 'active' : ''}`}
        onClick={() => setViewMode('card')}
        title="カード表示"
        aria-label="カード表示"
        aria-pressed={viewMode === 'card'}
      >
        <i className="fa-solid fa-image" aria-hidden="true"></i>
      </DsButton>
      <DsButton
        type="button"
        variant="secondary"
        icon
        className={`view-action ${viewMode === 'list' ? 'active' : ''}`}
        onClick={() => setViewMode('list')}
        title="リスト表示"
        aria-label="リスト表示"
        aria-pressed={viewMode === 'list'}
      >
        <i className="fa-solid fa-list" aria-hidden="true"></i>
      </DsButton>
      <DsButton
        type="button"
        variant="secondary"
        icon
        className={`view-action ${viewMode === 'calendar' ? 'active' : ''}`}
        onClick={() => setViewMode('calendar')}
        title="カレンダー表示"
        aria-label="カレンダー表示"
        aria-pressed={viewMode === 'calendar'}
      >
        <i className="fa-solid fa-calendar" aria-hidden="true"></i>
      </DsButton>
    </div>
  );
}

export default function ArtistEventListToolbar({
  handlePageSizeChange,
  isMobileSearchLayout,
  itemsPerPage,
  pageSizeOptions,
  setViewMode,
  sortOrder,
  toggleSortOrder,
  totalCount,
  viewMode,
}) {
  const renderSort = () => (
    <DsButton type="button" variant="secondary" size="sm" className="sort-toggle-action" onClick={toggleSortOrder}>
      並び順: {sortOrder === 'asc' ? '昇順' : '降順'}
    </DsButton>
  );

  return (
    <>
      {!isMobileSearchLayout && (
        <div className="event-toolbar">
          {renderSort()}
          <PageSizeSelector
            handlePageSizeChange={handlePageSizeChange}
            itemsPerPage={itemsPerPage}
            pageSizeOptions={pageSizeOptions}
          />
          <ViewModeSwitch setViewMode={setViewMode} viewMode={viewMode} />
          <div className="event-count" aria-live="polite">
            {formatItemCount(totalCount)}
          </div>
        </div>
      )}
      {/* SP: 並び順＋件数を左に寄せ、表示切り替えを右端に固定した1段ツールバー（件数表示は検索行へ集約） */}
      <div className="mobile-toolbar" aria-label="モバイル操作パネル">
        <div className="mobile-toolbar__lead">
          {renderSort()}
          <PageSizeSelector
            handlePageSizeChange={handlePageSizeChange}
            itemsPerPage={itemsPerPage}
            pageSizeOptions={pageSizeOptions}
          />
        </div>
        <ViewModeSwitch
          label="表示切り替え（モバイル）"
          setViewMode={setViewMode}
          viewMode={viewMode}
        />
      </div>
    </>
  );
}
